import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

const validateContactUsV2 = ({ firstName, lastName, email, categoryId, description }, descRequired) => {
  let errors = {};

  firstName = !isEmpty(firstName) ? firstName : '';
  lastName = !isEmpty(lastName) ? lastName : '';
  email = !isEmpty(email) ? email : '';
  categoryId = categoryId ?? '';
  if (!descRequired) {
    description = !isEmpty(description) ? description : '';
  }
  if (Validator.isEmpty(firstName)) {

    errors.firstName = 'required';
  }

  if (Validator.isEmpty(lastName)) {

    errors.lastName = 'required';
  }

  if (Validator.isEmpty(email)) {

    errors.email = 'required';

  } else if (!Validator.isEmail(email)) {

    errors.email = 'email';
  }

  if (!categoryId) {

    errors.categoryId = 'required';
  }

  if (!descRequired) {
    if (Validator.isEmpty(description)) {
      errors.description = 'required';
    }
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

export default validateContactUsV2;
